// extracted by mini-css-extract-plugin
export default {"heading":"Applicabilty_heading__UXsFz","text-orange":"Applicabilty_text-orange__6t80J"};